  class MultiCollectionsCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      window.loadSwiper.then((swiperLib) => {
        this.swiperLib = swiperLib;
        this._initCarousel();
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }

    _initCarousel() {
      const { Swiper } = this.swiperLib;

      const swiperParams = {
        slidesPerView: "auto",
        speed: 300,
        navigation: {
          nextEl: this.querySelector("[data-navigation-next]"),
          prevEl: this.querySelector("[data-navigation-previous]"),
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);
    }
  }

  if (!customElements.get("multi-collections-collection")) {
    customElements.define(
      "multi-collections-collection",
      MultiCollectionsCollection,
    );
  }
